var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("Start control your robot")]),_c('router-link',{attrs:{"to":{ name: 'rws' }}},[_vm._v("Activate subscription")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }